import { useAuthorization } from "~/contexts/authorizationProvider";
import { OutputTemplatePermission, RBACPermission } from "~/shared/types/RBACPermission";

/**
 * The single declaration of what the output-template feature requires (docs/AUTH_ROLES.md, "UI
 * permission gates"): the router is authoritative and this array is its mirror, so the nav entry,
 * route-level empty states and query `enabled` flags never disagree with the API.
 */
export const outputTemplateAccessPermissions: RBACPermission[] = [OutputTemplatePermission.access];

export const outputTemplateAccessDeniedMessage = "You do not have permission to access output templates.";

export const useCanAccessOutputTemplates = (): boolean => {
  const { hasPermission } = useAuthorization();
  return hasPermission(outputTemplateAccessPermissions);
};
